'use client';

// Third Party Plugins
import React, { useState, useCallback, useEffect, useMemo } from 'react';
// Types
import { PastGrantWinners } from '../../types';
import { ClientSidePastWinnersWrapperProps } from './types';
// Custom Components
import SearchForm from '../SearchForm';
import PastGrantWinnersList from '../PastGrantWinnersList';
import ImageContainer from '@/components/images/ImageContainer';
import LayoutContainer from '@/components/ui/LayoutContainer';
import HeroHeading from '@/components/ui/HeroHeading';
import Gallery from '@/components/images/Gallery';
// import Pagination from '@components/shared/Pagination';

const ClientSidePastGrantWinnersWrapper: React.FC<
  ClientSidePastWinnersWrapperProps
> = ({
  headingOne,
  pageImageBlock,
  pastGrantWinners,
  hasGallery,
  galleryManyBlock,
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredWinners, setFilteredWinners] = useState<PastGrantWinners[]>(
    [],
  );

  // Move useMemo for transformedPastGrantWinners before useCallback
  const transformedPastGrantWinners = useMemo(() => {
    return pastGrantWinners.map((winner) => ({
      ...winner,
      _id: winner._id || 'default-id',
      _type: winner._type || 'pastGrantWinner',
      slug: winner.slug || { current: 'default-slug' },
      pastGrantWinnerTitle: winner.pastGrantWinnerTitle || 'Untitled Winner',
      pastGrantWinnerContentExcerpt:
        winner.pastGrantWinnerContentExcerpt || 'No content available.',
      pastGrantWinnerTag: winner.pastGrantWinnerTag || 'No tag',
      pastWinnerImg: winner.pastWinnerImg || {
        alt: 'No image',
        asset: { url: '' },
      },
      publishDate: winner.publishDate || 'Unknown Date',
    }));
  }, [pastGrantWinners]);

  const searchWinners = useCallback(() => {
    if (!searchTerm.trim()) {
      setFilteredWinners(transformedPastGrantWinners);
      return;
    }
    const items = transformedPastGrantWinners.filter((winner) =>
      winner.pastGrantWinnerTitle
        .trim()
        .toLowerCase()
        .includes(searchTerm.trim().toLowerCase()),
    );
    setFilteredWinners(items || []);
  }, [searchTerm, transformedPastGrantWinners]);

  useEffect(() => {
    searchWinners();
  }, [searchTerm, searchWinners]);

  return (
    <>
      <HeroHeading>
        <h1>{headingOne}</h1>
        {pageImageBlock ? (
          <ImageContainer
            image={pageImageBlock.asset.url}
            width={751}
            height={194}
            type="dynamic"
            alt={pageImageBlock.alt || ''}
          />
        ) : null}
        <SearchForm searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      </HeroHeading>
      <LayoutContainer hasSectionGaps>
        <PastGrantWinnersList winners={filteredWinners} />
        {hasGallery && <Gallery images={galleryManyBlock || []} />}
      </LayoutContainer>
    </>
  );
};

export default ClientSidePastGrantWinnersWrapper;
